export default __webpack_public_path__ + "src/images/packages/the-african-renaissance/809355800bb34604b9ffbddeceb63a1c-2.jpg";